import React from 'react';

export default function InfoRow({
    label,
    value,
    mono = false,
    wrap = false,
    className = '',
}) {
    return (
        <div className={`flex items-baseline gap-4 py-1.5 ${className}`}>
            <dt className="text-sm text-gray-500 shrink-0 w-24">{label}</dt>
            <dd className={`text-sm text-gray-900 min-w-0 ${wrap ? 'whitespace-pre-wrap break-words' : 'truncate'} ${mono ? 'font-mono text-xs' : ''}`}>
                {value ?? <span className="text-gray-400">-</span>}
            </dd>
        </div>
    );
}
